module.exports = __webpack_public_path__ + "img/S10.271d4d6f.svg";